import { Box, TextField } from '@forgeglobal/design-framework';
import type { MaskitoOptions } from '@maskito/core';
import { maskitoNumber } from '@maskito/kit';
import { useMaskito } from '@maskito/react';

const { plugins, ...numberOptions } = maskitoNumber({
  min: 0,
  max: 100,
  maximumFractionDigits: 2,
});

const options = {
  ...numberOptions,
  plugins: [...plugins],
} as MaskitoOptions;

const PercentageInputCell = (props) => {
  const { onChange, value, ...input } = props.input;
  const { error, ...meta } = props.meta;
  const maskedInputRef = useMaskito({ options });

  return (
    <Box
      sx={{
        mt: 1,
        '& .MuiInputBase-input': { paddingTop: '10px' },
        '& .MuiInputBase-input:focus': { paddingTop: '10px' },
      }}>
      <TextField
        input={{
          ...input,
          value: `${value ?? '0'}`,
          onChange,
        }}
        meta={{
          ...meta,
        }}
        InputProps={{
          ref: maskedInputRef,
          endAdornment: <>%</>,
          onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            onChange(value === '' ? 0 : parseFloat(value));
          },
          style: {
            border: `1px solid ${props.meta.invalid ? 'red' : '#fff'}`,
            height: '34px',
          },
        }}
      />
    </Box>
  );
};

export default PercentageInputCell;
